import { render, staticRenderFns } from "./MerchantBalanceAccountNotif.vue?vue&type=template&id=f3f5427a&"
import script from "./MerchantBalanceAccountNotif.vue?vue&type=script&lang=js&"
export * from "./MerchantBalanceAccountNotif.vue?vue&type=script&lang=js&"
import style0 from "./MerchantBalanceAccountNotif.vue?vue&type=style&index=0&id=f3f5427a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports